import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=ef12a1ca"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "@/assets/Notification.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Notification.vue?vue&type=style&index=1&id=ef12a1ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports